<template>
  <div>
    <el-card shadow="always" body-style="padding:0px;width:100%;">
      <div id="chart_business_1" style="height: 720px; width: 100%"></div>
      <div id="chart_business_1_table" class="echart_table">
        <table id="chart_business_1_tab" class="tabletemp table-striped table-bordered tabletemp-hover">
          <thead>
            <tr title="返回">
              <th style="width: 60px">
                <div class="th-inner" @click="backEcharts('chart_business_1')">
                  <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
                </div>
                <div class="fht-cell"></div>
              </th>
              <th nowrap="nowrap" style="padding: 0.74rem; width: 270px">
                <div class="th-inner text-warning">省局</div>
                <div class="fht-cell">
                  <el-input
                    v-if="queryVisible"
                    v-model="query.provincename"
                    clearable
                    size="mini"
                    placeholder="请输入内容"
                    class="searchInput">
                    <el-button @click="goFilterList()" slot="append" size="mini" icon="el-icon-search"></el-button>
                  </el-input>
                </div>
              </th>
              <th nowrap="nowrap">
                <div class="th-inner text-warning">出版单位</div>
                <div class="fht-cell">
                  <el-input
                    v-if="queryVisible"
                    v-model="query.name"
                    clearable
                    size="mini"
                    placeholder="请输入内容"
                    class="searchInput">
                    <el-button @click="goFilterList()" slot="append" size="mini" icon="el-icon-search"></el-button>
                  </el-input>
                </div>
              </th>
              <th nowrap="nowrap">
                <div class="th-inner text-warning">
                  {{ this.targetyear + "年 " + this.category + " (万元)" }}
                  <i
                    @click="setQueryVisible()"
                    class="fa fa-filter searchFilerCls"
                    aria-hidden="true"
                    title="筛选"
                    style="margin-right: 5px" />
                  <i
                    @click="downloadData('chart_business_1_html')"
                    class="fa fa-download searchFilerCls"
                    aria-hidden="true"
                    title="导出" />
                </div>
                <div class="fht-cell">
                  <el-input
                    v-if="queryVisible"
                    v-model="query.value"
                    clearable
                    size="mini"
                    placeholder="请输入内容"
                    class="searchInput">
                    <el-button @click="goFilterList()" slot="append" size="mini" icon="el-icon-search"></el-button>
                  </el-input>
                </div>
              </th>
            </tr>
          </thead>
          <tbody id="chart_business_1_html" style="font-size: 14px !important">
            <tr>
              <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card>
    <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="first_finance_pie_chart_media" style="height: 300px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="first_finance_pie_chart_electr" style="height: 300px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="second_finance_pie_chart_media" style="height: 300px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="second_finance_pie_chart_electr" style="height: 300px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="first_finance_pie_chart_media_pay" style="height: 300px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="first_finance_pie_chart_electr_pay" style="height: 300px"></div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="15" style="padding: 15px 0px 0px 0px">
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="second_finance_pie_chart_media_pay" style="height: 300px"></div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="always" body-style="padding:0px;width:100%;">
          <div id="second_finance_pie_chart_electr_pay" style="height: 300px"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");

import { getFinanceChart1, getFinanceDetail } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: "2024",
      category: "音像",
      datalist: [],
      filtedData: [],

      queryVisible: false,
      query: {
        provincename: "",
        name: "",
        value: "",
      },

      financeMedia: {},
      financeElectr: {},
    };
  },
  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler(val) {
        this.chartTheme = val;
        if (this.activeName == "business") {
          this.goSearchBusinessCharts();
        }
      },
      immediate: true,
    },
    activeName: {
      handler(val) {
        if (val == "business") {
          var myChart = echarts.init(document.getElementById("chart_business_1"), this.chartTheme);
          this.chartResize(myChart);
          var ffpcm = echarts.init(document.getElementById("first_finance_pie_chart_media"), this.chartTheme);
          this.chartResize(ffpcm);
          var ffpce = echarts.init(document.getElementById("first_finance_pie_chart_electr"), this.chartTheme);
          this.chartResize(ffpce);
          var sfpcm = echarts.init(document.getElementById("second_finance_pie_chart_media"), this.chartTheme);
          this.chartResize(sfpcm);
          var sfpce = echarts.init(document.getElementById("second_finance_pie_chart_electr"), this.chartTheme);
          this.chartResize(sfpce);
          var ffpcmp = echarts.init(document.getElementById("first_finance_pie_chart_media_pay"), this.chartTheme);
          this.chartResize(ffpcmp);
          var ffpcep = echarts.init(document.getElementById("first_finance_pie_chart_electr_pay"), this.chartTheme);
          this.chartResize(ffpcep);
          var sfpcmp = echarts.init(document.getElementById("second_finance_pie_chart_media_pay"), this.chartTheme);
          this.chartResize(sfpcmp);
          var sfpcep = echarts.init(document.getElementById("second_finance_pie_chart_electr_pay"), this.chartTheme);
          this.chartResize(sfpcep);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async downloadData(id) {
      var columns = { provincename: "省局", name: "出版单位", value: this.category };
      let cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
      var list = [];
      for (var i in this.datalist) {
        var po = this.datalist[i];
        var data = {};
        for (var key in columns) {
          data[columns[key]] = po[key];
        }
        list.push(data);
      }
      var filename = `${this.targetyear}年${this.category}_${moment()}.xlsx`;
      var opts = Object.values(columns);
      var wsname = "Sheet1";
      const wb = XLSX.utils.book_new();
      const ws = await XLSX.utils.json_to_sheet(list, opts);
      ws["!cols"] = cellWidths;
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      await XLSX.writeFile(wb, `${filename}`);
    },
    initCharts() {
      this.goSearchBusinessCharts();
    },
    createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      let html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html +=
          ' <td style="text-align: center; vertical-align: middle;width:60px;padding: 0.74rem;">' +
          (Number(index) + 1) +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 270px;padding: 0.74rem;">' +
          item.provincename +
          "</td>";
        html += ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' + item.name + "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' +
          this.formatEmpty(item.value) +
          "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchBusinessCharts() {
      var years = [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024];
      var that = this;

      getFinanceChart1({ firstyear: this.searchFirstYear }).then((res) => {
        console.log("getFinanceChart1====", res);

        // echat对象
        var lineNames = [];
        var seriesList = [];
        // 数据
        var lineBase = {};
        if (res.base.length > 0) {
          var baseTags = {
            年销售收入: "totalsales",
            "年利润(税后)总额": "totalprofit",
          };

          // 一般是两组 音像一组 电子一组
          for (var record of res.base) {
            // 类型分类
            for (var tag of Object.keys(baseTags)) {
              // 年份数据
              var data = [];
              for (var i = 0; i < years.length; i++) {
                var baseYear = years[i];
                var isFirst = true;
                if (i % 2 == 1) {
                  isFirst = false;
                  baseYear = years[i - 1];
                }
                var colname = (isFirst ? "first" : "second") + baseTags[tag] + baseYear;
                data.push(record[colname]);
              }

              var typeName = "出版单位";
              lineBase[typeName + tag] = data;
            }
          }
        }

        lineNames.push(...Object.keys(lineBase));
        Object.keys(lineBase).forEach((item) => {
          // 线图
          // var series = {
          //   name: item,
          //   symbolSize: 5,
          //   type: "line",
          //   smooth: true,
          //   emphasis: {
          //     focus: "series",
          //   },
          //   // endLabel: {
          //   //   show: true,
          //   //   formatter: "{a}",
          //   //   distance: 20,
          //   // },
          //   lineStyle: {
          //     width: 4,
          //   },
          //   data: lineBase[item],
          // };

          var series = {
            name: item,
            type: "bar",
            barGap: 0,
            label: {
              // show: true,
              position: "insideBottom",
              distance: 15,
              align: "left",
              verticalAlign: "middle",
              rotate: 90,
              formatter: "{c}",
              fontSize: 16,
              rich: {
                name: {},
              },
            },
            emphasis: {
              focus: "series",
            },
            data: lineBase[item],
            xAxisIndex: 1,
            yAxisIndex: 1,
          };
          seriesList.push(series);
        });

        var lineFinace = {};
        if (res.finance.length > 0) {
          var financeTags = {
            年度销售收入: "sales",
            // 年度支出: "pay",
            "年度利润（税后）总额": "profit",
          };
          // 一般是两组 音像一组 电子一组
          for (var record of res.finance) {
            if (record.type == "音像") {
              that.financeMedia = record;
            } else if (record.type == "电子") {
              that.financeElectr = record;
            }
            // 类型分类
            for (var tag of Object.keys(financeTags)) {
              // 年份数据
              var data = [];
              for (var i = 0; i < years.length; i++) {
                var baseYear = years[i];
                var isFirst = true;
                if (i % 2 == 1) {
                  isFirst = false;
                  baseYear = years[i - 1];
                }
                var colname = (isFirst ? "first" : "second") + financeTags[tag] + baseYear;
                data.push(record[colname]);
              }

              var typeName = "";
              if (record.type == "音像") {
                typeName = "音像制品";
              } else if (record.type == "电子") {
                typeName = "电子出版物";
              }
              lineFinace[typeName + tag] = data;
            }
          }
        }

        lineNames.push(...Object.keys(lineFinace));
        Object.keys(lineFinace).forEach((item) => {
          // 线图
          // var series = {
          //   name: item,
          //   symbolSize: 5,
          //   type: "line",
          //   smooth: true,
          //   emphasis: {
          //     focus: "series",
          //   },
          //   // endLabel: {
          //   //   show: true,
          //   //   formatter: "{a}",
          //   //   distance: 20,
          //   // },
          //   lineStyle: {
          //     width: 4,
          //   },
          //   data: lineFinace[item],
          // };

          var series = {
            name: item,
            type: "bar",
            barGap: 0,
            label: {
              // show: true,
              position: "insideBottom",
              distance: 15,
              align: "left",
              verticalAlign: "middle",
              rotate: 90,
              formatter: "{c}",
              fontSize: 16,
              rich: {
                name: {},
              },
            },
            emphasis: {
              focus: "series",
            },
            data: lineFinace[item],
          };
          seriesList.push(series);
        });

        var chartParams = {
          title: "全国经营数据统计",
          // subtext: "单位数量：" + res.count,
          names: lineNames,
          years: years,
          series: seriesList,
        };

        setTimeout(function () {
          that.drawChartLine("chart_business_1", chartParams);
          that.draw2DPieChart();
          that.draw2DPieChartPay();
        }, 1000);
      });
    },
    drawChartLine: function (id, chartParams) {
      console.log("drawChartLine", chartParams);
      let that = this;
      this.disposeChart(id);
      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          // subtext: chartParams.subtext,
          left: "center",
          top: 10,
        },
        tooltip: {
          trigger: "item",
        },
        grid: [{ top: "55%" }, { bottom: "55%" }],
        legend: {
          show: true,
          //left:'60%',
          orient: "horizontal",
          // width:130,
          icon: "roundRect",
          bottom: 20,
          itemGap: 10,
          data: chartParams.names,
        },
        xAxis: [
          {
            type: "category",
            gridIndex: 0,
            data: chartParams.years,
          },
          {
            type: "category",
            gridIndex: 1,
            data: chartParams.years,
          },
        ],
        yAxis: [
          {
            gridIndex: 0,
            type: "value",
            name: "万元",
          },
          { gridIndex: 1, type: "value", name: "万元" },
        ],
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "数据列表", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("clickparams==", params);
        that.targetyear = params.name;
        that.category = params.seriesName;
        getFinanceDetail({
          firstyear: this.searchFirstYear,
          targetyear: params.name,
          category: params.seriesName,
        }).then((res) => {
          that.datalist = res.data;
          that.filtedData = res.data;
          that.createDataHtml(id, res.data);
          that.backEcharts(id, myChart, params);
        });

        console.log(params);
      });
      this.chartResize(myChart);
    },
    draw2DPieChart: function () {
      console.log(this.financeMedia);
      this.disposeChart("first_finance_pie_chart_media");
      var myChart1 = echarts.init(document.getElementById("first_finance_pie_chart_media"), this.chartTheme);
      var option1 = {
        title: {
          text: "2023年音像制品出版业务收入构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "出版业务收入构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: this.financeMedia.firstsales1, name: "发行销售" },
              { value: this.financeMedia.firstsales2, name: "出让版权" },
              { value: this.financeMedia.firstsales3, name: "出版活动" },
              { value: this.financeMedia.firstsales4, name: "审校加工" },
              { value: this.financeMedia.firstsales5, name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart1.setOption(option1);
      this.chartResize(myChart1);

      this.disposeChart("second_finance_pie_chart_media");
      var myChart2 = echarts.init(document.getElementById("second_finance_pie_chart_media"), this.chartTheme);
      var option2 = {
        title: {
          text: "2024年音像制品出版业务收入构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "出版业务收入构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: this.financeMedia.secondsales1, name: "发行销售" },
              { value: this.financeMedia.secondsales2, name: "出让版权" },
              { value: this.financeMedia.secondsales3, name: "出版活动" },
              { value: this.financeMedia.secondsales4, name: "审校加工" },
              { value: this.financeMedia.secondsales5, name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart2.setOption(option2);
      this.chartResize(myChart2);

      this.disposeChart("first_finance_pie_chart_electr");
      var myChart3 = echarts.init(document.getElementById("first_finance_pie_chart_electr"), this.chartTheme);
      var option3 = {
        title: {
          text: "2023年电子出版物出版业务收入构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "出版业务收入构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: this.financeElectr.firstsales1, name: "发行销售" },
              { value: this.financeElectr.firstsales2, name: "出让版权" },
              { value: this.financeElectr.firstsales3, name: "出版活动" },
              { value: this.financeElectr.firstsales4, name: "审校加工" },
              { value: this.financeElectr.firstsales5, name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart3.setOption(option3);
      this.chartResize(myChart3);

      this.disposeChart("second_finance_pie_chart_electr");
      var myChart4 = echarts.init(document.getElementById("second_finance_pie_chart_electr"), this.chartTheme);
      var option4 = {
        title: {
          text: "2024年电子出版物出版业务收入构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "出版业务收入构成",
            type: "pie",
            selectedMode: "single",
            radius: "50%",
            data: [
              { value: this.financeElectr.secondsales1, name: "发行销售" },
              { value: this.financeElectr.secondsales2, name: "出让版权" },
              { value: this.financeElectr.secondsales3, name: "出版活动" },
              { value: this.financeElectr.secondsales4, name: "审校加工" },
              { value: this.financeElectr.secondsales5, name: "其他收入" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            label: {
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart4.setOption(option4);
      this.chartResize(myChart4);
    },
    draw2DPieChartPay: function () {
      console.log(this.financeMedia);
      this.disposeChart("first_finance_pie_chart_media_pay");
      var myChart1 = echarts.init(document.getElementById("first_finance_pie_chart_media_pay"), this.chartTheme);
      var option1 = {
        title: {
          text: "2023年音像制品出版业务支出构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "支出构成",
            type: "pie",
            radius: "50%",
            data: [
              { value: this.financeMedia.firstpay12023, name: "人员成本" },
              { value: this.financeMedia.firstpay22023, name: "运营成本" },
              { value: this.financeMedia.firstpay32023, name: "劳务支出" },
              { value: this.financeMedia.firstpay42023, name: "包装费用" },
              { value: this.financeMedia.firstpay52023, name: "新媒体支出" },
              { value: this.financeMedia.firstpay62023, name: "固定资产" },
              { value: this.financeMedia.firstpay72023, name: "培训支出" },
              { value: this.financeMedia.firstpay82023, name: "其他支出" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart1.setOption(option1);
      this.chartResize(myChart1);

      this.disposeChart("second_finance_pie_chart_media_pay");
      var myChart2 = echarts.init(document.getElementById("second_finance_pie_chart_media_pay"), this.chartTheme);
      var option2 = {
        title: {
          text: "2024年音像制品出版业务支出构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "支出构成",
            type: "pie",
            radius: "50%",
            data: [
              { value: this.financeMedia.secondpay12024, name: "人员成本" },
              { value: this.financeMedia.secondpay22024, name: "运营成本" },
              { value: this.financeMedia.secondpay32024, name: "劳务支出" },
              { value: this.financeMedia.secondpay42024, name: "包装费用" },
              { value: this.financeMedia.secondpay52024, name: "新媒体支出" },
              { value: this.financeMedia.secondpay62024, name: "固定资产" },
              { value: this.financeMedia.secondpay72024, name: "培训支出" },
              { value: this.financeMedia.secondpay82024, name: "其他支出" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart2.setOption(option2);
      this.chartResize(myChart2);

      this.disposeChart("first_finance_pie_chart_electr_pay");
      var myChart3 = echarts.init(document.getElementById("first_finance_pie_chart_electr_pay"), this.chartTheme);
      var option3 = {
        title: {
          text: "2023年电子出版物出版业务支出构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "支出构成",
            type: "pie",
            radius: "50%",
            data: [
              { value: this.financeElectr.firstpay12023, name: "人员成本" },
              { value: this.financeElectr.firstpay22023, name: "运营成本" },
              { value: this.financeElectr.firstpay32023, name: "劳务支出" },
              { value: this.financeElectr.firstpay42023, name: "包装费用" },
              { value: this.financeElectr.firstpay52023, name: "新媒体支出" },
              { value: this.financeElectr.firstpay62023, name: "固定资产" },
              { value: this.financeElectr.firstpay72023, name: "培训支出" },
              { value: this.financeElectr.firstpay82023, name: "其他支出" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart3.setOption(option3);
      this.chartResize(myChart3);

      this.disposeChart("second_finance_pie_chart_electr_pay");
      var myChart4 = echarts.init(document.getElementById("second_finance_pie_chart_electr_pay"), this.chartTheme);
      var option4 = {
        title: {
          text: "2024年电子出版物出版业务支出构成",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "支出构成",
            type: "pie",
            radius: "50%",
            data: [
              { value: this.financeElectr.secondpay12024, name: "人员成本" },
              { value: this.financeElectr.secondpay22024, name: "运营成本" },
              { value: this.financeElectr.secondpay32024, name: "劳务支出" },
              { value: this.financeElectr.secondpay42024, name: "包装费用" },
              { value: this.financeElectr.secondpay52024, name: "新媒体支出" },
              { value: this.financeElectr.secondpay62024, name: "固定资产" },
              { value: this.financeElectr.secondpay72024, name: "培训支出" },
              { value: this.financeElectr.secondpay82024, name: "其他支出" },
            ],
            center: ["55%", "50%"],
            startAngle: 180,
            avoidLabelOverlap: true,
            label: {
              show: true,
              position: "outside",
              formatter: "{b}: \n{c} ({d}%)",
              alignTo: "labelLine",
              edgeDistance: "10%",
              minMargin: 15,
            },
            labelLine: {
              length2: 20,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            saveAsImage: { show: true, icon: this.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 14,
          right: 4,
        },
      };
      // 绘制图表
      myChart4.setOption(option4);
      this.chartResize(myChart4);
    },

    draw3DPieChart: function (id, chartParams) {
      console.log("draw3DPieChart", chartParams);
      var id = "finance_pie_chart_media";
      let that = this;
      this.disposeChart(id);
      var myChart = echarts.init(document.getElementById(id), this.chartTheme);

      var option = {
        grid3D: {
          show: false,
          boxHeight: 0.01,
          // top: '30%',
          bottom: "50%",
          viewControl: {
            distance: 300,
            alpha: 35,
            beta: 60,
            autoRotate: false, // 自动旋转
          },
        },
      };
      myChart.setOption(option);
      this.chartResize(myChart);
    },
    get3DPieData: function (startRatio, endRatio, isSelected, isHovered, k, height) {
      // 计算
      const midRatio = (startRatio + endRatio) / 2;
      const startRadian = startRatio * Math.PI * 2;
      const endRadian = endRatio * Math.PI * 2;
      const midRadian = midRatio * Math.PI * 2;

      // 如果只有一个扇形，则不实现选中效果。
      if (startRatio === 0 && endRatio === 1) {
        isSelected = false;
      }

      // 通过扇形内径/外径的值，换算出辅助参数 k（默认值 1/3）
      k = typeof k !== "undefined" ? k : 1 / 3;

      // 计算选中效果分别在 x 轴、y 轴方向上的位移（未选中，则位移均为 0）
      const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
      const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;

      // 计算高亮效果的放大比例（未高亮，则比例为 1）
      const hoverRate = isHovered ? 1.05 : 1;

      // 返回曲面参数方程
      return {
        u: {
          min: -Math.PI,
          max: Math.PI * 3,
          step: Math.PI / 32,
        },

        v: {
          min: 0,
          max: Math.PI * 2,
          step: Math.PI / 20,
        },

        x: function (u, v) {
          if (u < startRadian) {
            return offsetX + Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetX + Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
        },

        y: function (u, v) {
          if (u < startRadian) {
            return offsetY + Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          if (u > endRadian) {
            return offsetY + Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate;
          }
          return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
        },

        z: function (u, v) {
          if (u < -Math.PI * 0.5) {
            return Math.sin(u);
          }
          if (u > Math.PI * 2.5) {
            return Math.sin(u);
          }
          return Math.sin(v) > 0 ? 1 * height : -1;
        },
      };
    },
    chartResize(myChart) {
      myChart.resize(true);
    },
    backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible() {
      this.queryVisible = !this.queryVisible;
    },
    goFilterList() {
      console.log("goFilterList", this.query);
      this.filtedData = this.datalist.filter((item) => {
        return (
          item.provincename.indexOf(this.query.provincename) > -1 &&
          item.name.indexOf(this.query.name) > -1 &&
          (item.value + "").indexOf(this.query.value) > -1
        );
      });
      this.createDataHtml("chart_business_1", filtedData);
    },
    formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    },
  },
  created: function () {
    let that = this;
    window.addEventListener("resize", () => {
      that.initCharts();
    });
    that.initCharts();
  },
};
</script>

<style lang="scss" scoped>
.echart_table {
  height: 720px;
  width: 100%;
  overflow: hidden;
  display: none;
}

.echart_table table tbody {
  display: block;
  height: 720px;
  overflow-y: auto;
}

.searchFilerCls {
  float: right;
  padding-top: 3px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// StatisticalFinance.vue?269e2f5f